import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { useCreateCustomPage } from '../../../../../api/custom-pages.js';
import { PageHeading } from '../../../../../components/PageHeading.js';
import styles from '../../../../../custom-data/custom-data.module.css';
import { CustomPageForm } from '../../../../../custom-data/CustomPageForm.js';

/** `/websites/:websiteId/custom-data/new`. Once saved, the URL becomes the page's own. */
export const Route = createFileRoute('/_app/websites/$websiteId/custom-data/new')({
  component: NewCustomPage,
});

function NewCustomPage() {
  const { websiteId } = Route.useParams();
  const navigate = useNavigate();
  const create = useCreateCustomPage(websiteId);

  return (
    <>
      <Link className={styles.back} to="/websites/$websiteId/custom-data" params={{ websiteId }}>
        <ArrowLeft aria-hidden="true" width={14} height={14} strokeWidth={1.75} />
        Back to custom data
      </Link>
      <div className={styles.header}>
        <PageHeading documentTitle="New custom page">New custom page</PageHeading>
      </div>
      <CustomPageForm
        page={null}
        isSaving={create.isPending}
        onSave={async (body) => {
          const page = await create.mutateAsync(body);
          await navigate({
            to: '/websites/$websiteId/custom-data/$customPageId',
            params: { websiteId, customPageId: page.id },
            search: { saved: true },
            replace: true,
          });
        }}
      />
    </>
  );
}
